export const white = '#FFFFFF'
export const black = '#181818'
export const granite = '#b3b3b3'
export const outline = '#e6e6e7'
export const soft = '#f4f4f5'
export const vip = '#d6b56e'
export const success = '#70EAB4'
export const error = '#ff5c4b'
